import styled from 'styled-components';
import { memo } from 'react';
import { Card, CardContent, Box } from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import type { DatesSetArg, EventContentArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { format } from 'date-fns';

const noop = () => {};

const FullCalendarWrapper = styled.div``;

type Props = {
  events: Record<any, any>; // Fix me
  headerToolBar?: {
    left?: string;
    center?: string;
    right?: string;
  };
  initialDate?: string; // YYYY-MM-DD
  initialView?: string;
  height?: number;
  aspectRatio?: number;
  datesSet?: (arg: DatesSetArg) => void;
  eventContent?: (arg: EventContentArg) => JSX.Element;
  renderHeader?: () => JSX.Element;
};

const SimpleCalendar = ({
  events,
  headerToolBar = {
    left: 'prev,next',
    center: 'title',
    right: 'dayGridDay,dayGridWeek,dayGridMonth',
  },
  initialDate = format(new Date(), 'yyyy-MM-dd'),
  initialView = 'dayGridMonth',
  height = 450,
  aspectRatio = 3.5,
  datesSet = noop,
  eventContent,
  renderHeader,
}: Props) => {
  return (
    <Card>
      {renderHeader ? renderHeader() : <></>}
      <CardContent>
        <FullCalendarWrapper>
          <FullCalendar
            initialView={initialView}
            initialDate={initialDate}
            plugins={[dayGridPlugin, interactionPlugin]}
            events={events}
            headerToolbar={headerToolBar}
            aspectRatio={aspectRatio}
            height={height}
            datesSet={datesSet}
            dayCellClassNames={'dayCellClassNames'}
            eventContent={eventContent}
          />
        </FullCalendarWrapper>
      </CardContent>
    </Card>
  );
};

export default memo(SimpleCalendar);
